/**
 * Get the content of a meta tag by name
 * @param {string} name - The name attribute of the meta tag
 * @returns {string|undefined} The content of the meta tag or undefined if not found
 */
export function getMetaValue(name) {
  const element = findElement(document.head, `meta[name="${name}"]`);
  if (element) {
    return element.getAttribute("content");
  }
}

/**
 * Find an element in the DOM using a CSS selector
 * @param {Document|Element} root - The root element to search from
 * @param {string} selector - The CSS selector to search for
 * @returns {Element|null} The found element or null if not found
 */
export function findElement(root, selector) {
  if (typeof root === "string") {
    selector = root;
    root = document;
  }
  return root.querySelector(selector);
}

/**
 * Convert an array-like object to an array
 * @param {Array|ArrayLike} value - The value to convert to an array
 * @returns {Array} The converted array
 */
export function toArray(value) {
  if (Array.isArray(value)) {
    return value;
  } else if (Array.from) {
    return Array.from(value);
  } else {
    return [].slice.call(value);
  }
}

/**
 * Remove an element from the DOM
 * @param {Element} el - The element to remove
 */
export function removeElement(el) {
  if (el && el.parentNode) {
    el.parentNode.removeChild(el);
  }
}

/**
 * Insert an element after a reference node
 * @param {Element} el - The element to insert
 * @param {Element} referenceNode - The node to insert after
 * @returns {Element} The inserted element
 */
export function insertAfter(el, referenceNode) {
  return referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
}
